import { render, staticRenderFns } from "./CommentsInput.vue?vue&type=template&id=7ef6f868&scoped=true&"
import script from "./CommentsInput.vue?vue&type=script&lang=js&"
export * from "./CommentsInput.vue?vue&type=script&lang=js&"
import style0 from "./CommentsInput.vue?vue&type=style&index=0&id=7ef6f868&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./CommentsInput.vue?vue&type=style&index=1&id=7ef6f868&prod&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6f868",
  null
  
)

export default component.exports